<template>
  <div :class="$style.wrap">
    <select-type ref="selectType" />
    <div :class="$style.find_btn">
      <van-button
        round
        type="primary"
        size="mini"
        tag="input"
        native-type="submit"
        value="查询订单"
        @click="find"
      />
    </div>
  </div>
</template>
<script>
import SelectType from "./commpents/SelectType";
export default {
  name: "invoiceList",
  data() {
    return {
      initial: true,
      amount: 0,
      allSelection: false,
      checkedIdList: [],
      total: 1,
      showPopup: false,
      list: [],
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  components: {
    SelectType
  },
  mounted() {
    this.$ls.set("timeActive", null);
    this.$ls.set("gameActive", null);
  },
  methods: {
    find() {
      this.$refs.selectType.setActive();
      this.$router.replace({
        path: this._anchor.invoiceList.path
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === "/invoiceRules") {
      this.$ls.set("timeActive", null);
      this.$ls.set("gameActive", null);
    }
    next();
  }
};
</script>
<style module lang="less">
:global {
  html #app,
  body #app {
    height: 100%;
  }
}
.wrap {
  position: relative;
  padding-top: 1.1rem;
}

.find_btn {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 1rem;
}
</style>
